import Images from "../../../../../assets/js/Images";

export const step1 = [
  {
    type: "multiselect",
    name: "reasonForVisit",
    que: "What brings you here today?",
    options: [
      {
        value: "67d90056c2c4d5ab747f8b3b",
        image: Images.stress,
        label: "I feel stressed or anxious",
      },
      {
        image: Images.mind,
        value: "67d90056c2c4d5ab747f8b40",
        label: "I want to improve focus or mindfulness",
      },
      {
        value: "67d90056c2c4d5ab747f8b3c",
        image: Images.balance,
        label: "I need help balancing work and life",
      },
      {
        value: "67d90056c2c4d5ab747f8b3d",
        image: Images.exercise,
        label: "I'm looking to improve my health and energy",
      },
      {
        image: Images.careerPath,
        value: "67d90056c2c4d5ab747f8b32",
        label: "I'm facing challenges in my career",
      },
      {
        value: "67d90056c2c4d5ab747f8b34",
        image: Images.selfConfidence,
        label: "I want to feel more confident and in control",
      },
      {
        image: Images.family,
        value: "67d90056c2c4d5ab747f8b33",
        label: "I'm having relationship or family struggles",
      },
      {
        value: "67d90056c2c4d5ab747f8b34",
        image: Images.businessmanWithDoubts,
        label: "I'm not sure — I'm just exploring",
      }, {
        value: "695751a16eb048cf622268e5",
        image: Images.businessmanWithDoubts,
        label: "I am worried about ageing",
      }, {
        value: "695751a16eb048cf622268e5",
        image: Images.businessmanWithDoubts,
        label: "I want to look and feel better",
      },
    ]
  }
]

export const step2 = [
  {
    name: "areaToImprove",
    que: "Which area of your life would you most like to improve?",
    options: [
      {
        value: "67d90056c2c4d5ab747f8b34",
        image: Images.selfConfidence,
        label: "Personal Growth / Confidence",
      },
      {
        image: Images.stress,
        value: "67d90056c2c4d5ab747f8b3b",
        label: "Stress & Mindfulness",
      },
      {
        image: Images.exercise,
        value: "67d90056c2c4d5ab747f8b3d",
        label: "Physical Health & Energy",
      },
      {
        value: "67d90056c2c4d5ab747f8b3c",
        image: Images.careerPath,
        label: "Career or Work Life",
      },
      {
        image: Images.family,
        value: "67d90056c2c4d5ab747f8b33",
        label: "Family or Parenting Support",
      },
      {
        image: Images.deposit,
        value: "67d90056c2c4d5ab747f8b39",
        label: "Financial Wellness",
      },
      {
        value: "67d90056c2c4d5ab747f8b39",
        image: Images.brokenHeart,
        label: "Relationships & Communication",
      },
      {
        value: "67d90056c2c4d5ab747f8b41",
        image: Images.stressManagement,
        label: "Spiritual or Lifestyle Wellness",
      },
    ]
  },
]

export const step3 = [
  {
    name: "preferredSupportType",
    que: "What type of support feels right for you right now?",
    options: [
      {
        image: Images.coach,
        value: "oneOnOneCoaching",
        label: "One-on-One Coaching",
      },
      {
        value: "workshops",
        image: Images.coach2,
        label: "Group Classes or Workshops",
      },
      {
        value: "courses",
        image: Images.streaming,
        label: "Self-guided Courses or Tools",
      },
      {
        value: "gentleMovement",
        image: Images.yogaPosition,
        label: "Gentle Movement (e.g., Yoga, Tai Chi)",
      },
      {
        value: "meditation",
        image: Images.meditation,
        label: "Guided Meditation & Breathing Techniques",
      },
      {
        value: "guidance",
        image: Images.stressManagement,
        label: "Nutrition & Lifestyle Guidance",
      },
      {
        value: "notSure",
        image: Images.businessmanWithDoubts,
        label: "Not Sure Yet – Show Me All Options",
      },
    ]
  },
]

export const step4 = [
  {
    name: "preferCulturalMatch",
    que: "Would you prefer to work with someone who understands your background or lifestyle?",
    options: [
      {
        value: "experience",
        image: Images.checkmark,
        label: "Yes, I'd prefer someone with specific experience (e.g., working moms, young professionals, etc.)",
      },
      {
        value: "noPreference",
        label: "No preference",
        image: Images.noStopping,
      },
      {
        value: "reviewProfiles",
        image: Images.businessmanWithDoubts,
        label: "I'd like to review profiles and choose myself",
      },
    ]
  },
]

export const step5 = [
  {
    name: "prioritySupportFactor",
    que: "Which matters most when choosing your support?",
    options: [
      {
        value: "67d90056c2c4d5ab747f8b3b",
        image: Images.meditation,
        label: "Feeling more calm and centered",
      },
      {
        value: "67d90056c2c4d5ab747f8b34",
        image: Images.careerPath,
        label: "Finding direction in my life or career",
      },
      {
        value: "67d90056c2c4d5ab747f8b3d",
        image: Images.exercise,
        label: "Improving my physical health and energy",
      },
      {
        value: "67d90056c2c4d5ab747f8b33",
        image: Images.family,
        label: "Creating more balance in relationships or family",
      },
      {
        value: "67d90056c2c4d5ab747f8b39",
        image: Images.stressManagement,
        label: "Managing financial stress or goals",
      },
      {
        value: "67d90056c2c4d5ab747f8b34",
        image: Images.task,
        label: "All of the above",
      },
    ]
  },
]

export const step6 = [
  {
    name: "preferredConnectTime",
    que: "When would you ideally like to connect?",
    options: [
      {
        value: "mornings",
        image: Images.sunrise,
        label: "Weekday Mornings",
      },
      {
        value: "evenings",
        image: Images.moon,
        label: "Weekday Evenings",
      },
      {
        label: "Weekends",
        value: "weekends",
        image: Images.weekend,
      },
      {
        value: "flexible",
        label: "I'm flexible",
        image: Images.flexibility,
      },
    ]
  },
  {
    name: "supportFormatType",
    que: "Preferred format?",
    options: [
      // {
      //   value: "video",
      //   label: "Video Sessions",
      //   image: Images.videoCamera,
      // },
      // {
      //   value: "phone",
      //   image: Images.mic,
      //   label: "Audio/Phone",
      // },
      {
        value: "chat",
        label: "Text/Chat",
        image: Images.chat,
      },
      {
        value: "noPreference",
        label: "No preference",
        image: Images.feedback2,
      },
    ]
  },
]

export const step7 = [
  {
    name: "recommendationPreference",
    que: "Would you like us to recommend specialists, resources, or both?",
    options: [
      {
        value: "specialists",
        image: Images.talking,
        label: "Recommend Specialists",
      },
      {
        image: Images.resource,
        value: "articlesOrCourses",
        label: "Show Me Articles, Courses, and Tools",
      },
      {
        label: "Both",
        value: "both",
        image: Images.task,
      },
    ]
  },
]